module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-85.f7e127e0.svg";